import React from 'react';
import PropTypes from 'prop-types';

export const FlashContext = React.createContext();

const initialState = {
  flash: {
    message: '',
    title: '',
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_FLASH':
      return {
        ...state,
        flash: action.flash,
      };
    case 'CLEAR_FLASH':
      return {
        ...state,
        flash: {
          message: '',
          title: '',
        },
      };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};

export const FlashProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const setFlash = (flash) => {
    dispatch({
      type: 'SET_FLASH',
      flash: flash?.message ? flash : { message: flash },
    });
  };

  const getFlash = () => {
    const flash = { ...state.flash };
    clearFlash();
    return flash;
  };

  const clearFlash = () => {
    dispatch({ type: 'CLEAR_FLASH' });
  };

  return (
    <FlashContext.Provider value={{ state, dispatch, setFlash, getFlash, clearFlash }}>
      {children}
    </FlashContext.Provider>
  );
};

FlashProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
